import styled from 'styled-components';
import { Palette } from 'config';

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;

  background: ${() => Palette.PrimaryGray._000};
  padding: 12px 24px;
  width: 100%;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const GroupButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-left: auto;

  > :last-child {
    margin-left: 16px;
  }
`;
